import type { GuideStep } from '../types';

/**
 * A "Nasıl yapılır" guide in progress (DECISIONS.md §213). Kept in localStorage so the walk survives full page loads
 * (the guide sends the user to other screens); the main bundle reads it to decide whether to load the player at all.
 */
export const TOUR_KEY = 'fetrace.tour';
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export interface TourState {
  ticket: number;
  guide: { id: number; title: string; steps: GuideStep[] };
  step: number;
  /** `ask` = the steps are over (or the user closed the guide): "İstediğinizi yapabildiniz mi?" */
  phase: 'step' | 'ask';
  at: number;
}

export function readTour(): TourState | null {
  try {
    const raw = localStorage.getItem(TOUR_KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as TourState;
    if (!s?.guide?.steps?.length || Date.now() - (s.at ?? 0) > MAX_AGE_MS) {
      localStorage.removeItem(TOUR_KEY);
      return null;
    }
    return s;
  } catch {
    return null;
  }
}

export function writeTour(s: TourState | null): void {
  try {
    if (s) localStorage.setItem(TOUR_KEY, JSON.stringify({ ...s, at: Date.now() }));
    else localStorage.removeItem(TOUR_KEY);
  } catch {
    /* storage blocked: the guide still runs on this page */
  }
}

/** `/borclular/*` → one segment per `*`; trailing slashes and the query string do not matter. */
export function matchPath(pattern: string, path: string): boolean {
  const clean = (p: string) => (p.split(/[?#]/)[0] ?? '').replace(/\/+$/, '') || '/';
  const re = clean(pattern)
    .split('*')
    .map((part) => part.replace(/[.+?^${}()|[\]\\]/g, '\\$&'))
    .join('[^/]+');
  return new RegExp('^' + re + '$').test(clean(path));
}
